import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import noImage from "../../assets/images/no_image.jpg";
import * as utils from "../../Utils/comman";
import moment from "moment";
import Swal from "sweetalert2";

function View(props) {
  const { rowData } = props;
  const [note, setNote] = useState("");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({ image: [] });
  const [loadingAccept, setLoadingAccept] = useState(false); // State to manage loading for Accept button
  const [loadingReject, setLoadingReject] = useState(false);
  const [isValidImage, setisValidImage] = useState(false);
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [isDocDragging, setIsDocDragging] = useState(false);
  const [status, setStatus] = useState("");
  const allowedFileTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleAccept = () => {
    setStatus("1");
  };

  const handleReject = (e) => {
    // handleRejectChange("reject");
    const validationErrors = validate();
    setErrors(validationErrors);

    if (note !== "") setStatus("2");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "note") {
      setNote(value);
      console.log(errors, "yeh hai");

      setErrors((prevErrors) => ({
        ...prevErrors,
        note: value ? "" : prevErrors.note,
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!note) {
      newErrors.note = "Comment is required";
    }
    return newErrors;
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      return;
    }
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      image: [...prevFormData.image, ...validFiles],
    }));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);

    const files = Array.from(e.dataTransfer.files);
    const validFiles = files.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      setisValidImage(false);
      return;
    } else {
      setisValidImage(true);
    }
    setFormData({ ...formData, image: [...formData.image, ...validFiles] });
    //setFormData((prevFiles) => [...prevFiles, ...validFiles]);
  };
  const handleDeleteImage = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData((prevFormData) => {
          const updatedImages = [...prevFormData.image];
          if (typeof updatedImages[index] === "object") {
            // Handle File object
            updatedImages.splice(index, 1);
          } else if (typeof updatedImages[index] === "string") {
            // Handle URL string
            updatedImages.splice(index, 1); // Simply remove the URL from the array
          }
          return {
            ...prevFormData,
            image: updatedImages,
          };
        });
      }
    });
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (status === "1" || status === "2") {
      if (status === "1") {
        sendStatus("accept");
      } else if (status === "2") {
        sendStatus("reject");
      }
    }
  }, [status, note]);

  const sendStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (status !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("operator_status", status);
      formData.image.forEach((img, index) => {
        if (typeof img === "string") {
          bodyFormData.append(`document[${index}]`, img);
        } else {
          if (!img.isDeleted) {
            bodyFormData.append(`document[${index}]`, img);
          }
          // bodyFormData.append(`availableImg[0]`, "");
        }
      });

      bodyFormData.append("notes", note);

      utils
        .callAPI(
          "post",

          "/sales/ClaimOrderStatus",

          bodyFormData
        )
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                status === "1"
                  ? "The Claim has been accepted."
                  : "The Claim has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h4></h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Card>
            <RB.CardHeader>
              <h6 className={"mb-0"}>Claim Details</h6>
            </RB.CardHeader>
            <RB.CardBody>
              <RB.Row>
                <RB.Col md={6} className="mb-3">
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Name
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData?.ordersdata?.channel_partner_name}
                  </p>
                </RB.Col>
                <RB.Col md={6} className="mb-3">
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Order No.
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData?.ordersdata?.order_id}
                  </p>
                </RB.Col>
              </RB.Row>

              <RB.Row>
                <RB.Col md={6} className="mb-3">
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Invoice No.
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData?.pi_response?.main_invoice_no}
                  </p>
                </RB.Col>
                <RB.Col md={6} className="mb-3">
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Date
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {moment(rowData?.pi_response?.main_invoice_date).format(
                      "DD/MM/YYYY"
                    )}
                  </p>
                </RB.Col>
              </RB.Row>

              <RB.Row>
                <RB.Col md={6} className="mb-3">
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Claim Title
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData.claim_type}
                  </p>
                </RB.Col>
                <RB.Col md={6} className="mb-3">
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Description
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData.notes}
                  </p>
                </RB.Col>
              </RB.Row>

              {rowData?.document.length > 0 && (
                <div>
                  <h6 className="mt-4">Attachments</h6>
                  <hr className="hr-lg mt-1" />
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    {rowData?.document.map((attachment, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>
                        <a
                          href={attachment}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "blue", textDecoration: "none" }}
                        >
                          Attachment {index + 1}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </RB.CardBody>
          </RB.Card>

          {rowData.operator_remarks !== "" && (
            <>
              <h6>Comment</h6>
              <hr className="hr-lg mt-1" />
            </>
          )}

          <>
            {rowData?.operator_status !== null ? (
              <>
                {rowData.operator_remarks !== "" && (
                  <RB.Col md={6} className="mb-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Note
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.operator_remarks}
                    </p>
                  </RB.Col>
                )}

                {rowData?.operator_attachment.length > 0 && (
                  <div>
                    <h6 className="small">Attachments</h6>
                    <hr className="hr-md" />

                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      {rowData?.operator_attachment.map((attachment, index) => (
                        <li key={index} style={{ marginBottom: "10px" }}>
                          <a
                            href={attachment}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "blue", textDecoration: "none" }}
                          >
                            Attachment {index + 1}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            ) : (
              <div>
                <RB.Col md={12} className="no-validation-icon">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Note"
                      controlId="note"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="textarea"
                        type="text"
                        placeholder="Enter your note here"
                        name="note"
                        value={note}
                        onChange={handleInputChange}
                        maxLength={500}
                        isInvalid={!!errors.note}
                        // required={status !== "1"}
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        {errors.note}
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={12}>
                  <h6 className="mb-1 small">Attachments</h6>

                  <RB.Row className="mt-3 g-3 mb-3">
                    {formData.image.map((file, index) => {
                      const isString = typeof file === "string";
                      const fileUrl = isString
                        ? file
                        : URL.createObjectURL(file);
                      const fileName = isString ? file : file.name;

                      // Check file extension
                      const extension = fileName.split(".").pop().toLowerCase();
                      const isImage = ["jpg", "jpeg", "png"].includes(
                        extension
                      );

                      return (
                        <RB.Col className="col-md-6 col-lg-4" key={index}>
                          <div className="position-relative mb-4">
                            <div className="document-image text-center">
                              {isImage ? (
                                <img
                                  src={fileUrl}
                                  alt={`Attachment ${index + 1}`}
                                  className="img-fluid"
                                  style={{
                                    maxHeight: "200px",
                                    objectFit: "contain",
                                  }}
                                />
                              ) : (
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div
                                    style={{
                                      padding: "20px",
                                      border: "1px dashed #ccc",
                                      borderRadius: "8px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    <i
                                      className="material-icons-outlined"
                                      style={{ fontSize: "36px" }}
                                    >
                                      description
                                    </i>
                                    <div className="mt-2 small">
                                      📎 {extension.toUpperCase()} File
                                    </div>
                                  </div>
                                </a>
                              )}
                            </div>
                            <RB.Button
                              variant="danger"
                              className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                              onClick={() => handleDeleteImage(index)}
                            >
                              <i className="material-icons-outlined">delete</i>
                            </RB.Button>
                          </div>
                        </RB.Col>
                      );
                    })}

                    <RB.Col className="col-md-6 col-lg-4">
                      <div
                        className={`border p-4 text-center d-flex flex-column align-items-center ${
                          isDraggingOver ? "bg-info" : ""
                        }`}
                        onDragOver={(e) => handleDragOver(e, "image")}
                        onDragEnter={(e) => handleDragEnter(e, "image")}
                        onDragLeave={(e) => handleDragLeave(e, "image")}
                        onDrop={(e) => handleDrop(e, "image")}
                      >
                        <div className="avatar avatar-circle avatar-lg bg-light text-dark">
                          <i className="material-icons-outlined">
                            cloud_upload
                          </i>
                        </div>
                        <p className="mb-0">Drag & Drop your images here</p>
                        <small className="mb-2">or</small>
                        <div>
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleImageChange}
                            id="securityChequeInput"
                          />
                          <RB.Button
                            variant="primary"
                            className="me-2"
                            onClick={() =>
                              document
                                .getElementById("securityChequeInput")
                                .click()
                            }
                          >
                            <i className="las la-file-upload me-1"></i>Browse
                            Images
                          </RB.Button>
                        </div>
                      </div>
                      <span className={`${isValidImage ? "text-danger" : ""}`}>
                        <small>
                          *Note: Only JPG, JPEG, PNG, PDF, Word, and Excel files
                          are allowed
                        </small>
                      </span>
                    </RB.Col>
                  </RB.Row>
                </RB.Col>

                <>
                  <RB.Button
                    className="me-2"
                    style={{ backgroundColor: "#37c830", color: "white" }}
                    onClick={handleAccept}
                    disabled={loadingAccept} // Disable button while loading
                  >
                    {loadingAccept ? (
                      <RB.Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Accept"
                    )}
                  </RB.Button>
                  <RB.Button
                    style={{ backgroundColor: "red", color: "white" }}
                    onClick={handleReject}
                    disabled={loadingReject} // Disable button while loading
                  >
                    {loadingReject ? (
                      <RB.Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Reject"
                    )}
                  </RB.Button>
                </>
              </div>
            )}
          </>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
